import React, { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { setCalculationWindowAction } from '../../../../../redux/slices/oldBuilder';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import {
  QueryType,
  RetentionCalculationWindowKey,
} from '../../../../../utils/apollo/graphqlSchema';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';
import { retentionCalculationWindowTooltips } from '../../../../../components/KubitTooltip/globalTooltips';

const CalculationWindow = () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector((state) =>
    builderDefaultOptionsSelector(state),
  );
  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(
    defaultOptions?.type === QueryType.Retention &&
      selectedOptions?.type === QueryType.Retention,
  );

  const { calculationWindows } = defaultOptions;
  const { calculationWindow } = selectedOptions;

  const handleChange = (value: RetentionCalculationWindowKey) => {
    dispatch(
      setCalculationWindowAction({
        calculationWindowKey: value,
      }),
    );
  };

  const calculationWindowOptions = useMemo(
    () =>
      calculationWindows.map((cw) => ({
        ...cw,
        tooltip: retentionCalculationWindowTooltips[cw.key],
      })),
    [calculationWindows],
  );

  return (
    <BuilderEnumSelect
      label={'retention based on'}
      enumOptions={calculationWindowOptions}
      selectedOption={calculationWindow || null}
      onChange={handleChange}
    />
  );
};

export default CalculationWindow;
